import { ProIp } from "./ApiURL";

//postMapping :id

export const getMemberApi = ProIp + "Members/getMembers/mob/";

//postMapping

export const updateStatusAPI = ProIp + "Members/updateStatus/mob";

//PostMapping Create Member

export const createMemberAPI = ProIp + "Members/createMembers/mob"

//PostMapping Delete Member

export const deleteMemberAPI = ProIp + "Members/deleteMembers/mob"